import React from 'react';

import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import FormControlLabel from '@mui/material/FormControlLabel';

import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import SvgIcon from "@mui/material/SvgIcon";
import Icon from "@mui/material/Icon";
import Stack from '@mui/material/Stack';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

// import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';

import MenuIcon from '@mui/icons-material/Menu';


import Card from '@mui/material/Card';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import TextField from '@mui/material/TextField';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';

import RemoveCircleOutlinedIcon from '@mui/icons-material/RemoveCircleOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

import InputAdornment from '@mui/material/InputAdornment';

import Divider from '@mui/material/Divider';

import { NumericFormat } from 'react-number-format';

import NumberInput from "./NumberInput.js";

import ScoreDisplayer from "../ScoreDisplayer.js"

import settingSystem from "../SettingSystem.js"
import SheetMusicPlayer from './SheetMusicPlayer.js';

import AudiotrackIcon from '@mui/icons-material/Audiotrack';

import tutorialImage1 from "./welcome-page-tutorial-1.png"
import tutorialImage2 from "./welcome-page-tutorial-2.png"
import tutorialImage3 from "./welcome-page-tutorial-3.png"
import tutorialImage4 from "./welcome-page-tutorial-4.png"
import tutorialImage5 from "./welcome-page-tutorial-5.png"

import tutorialImageTC1 from "./welcome-1-tc.png"
import tutorialImageTC2 from "./welcome-2-tc.png"
import tutorialImageTC3 from "./welcome-3-tc.png"
import tutorialImageTC4 from "./welcome-4-tc.png"
import tutorialImageTC5 from "./welcome-5-tc.png"

import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper";


import { styled } from '@mui/material/styles';

import TextManager from '../TextManager.js';


const StyledCard = styled(Card)(({ theme }) => ({
	maxWidth: "500px",
	width: "100%",
	// height: "1000px",
	// maxHeight: "100%",
	height: "320px",
	minHeight: "320px",

	background: "rgba(255,255,255,0.5)",
	backdropFilter: "blur(2px)",
	padding: "10px 10px",
	boxSizing: "border-box",

}));

const TutorialText = styled(Typography)(({ theme }) => ({
	fontSize: "18px",
	lineHeight: "120%",
	marginTop: "10px",

}));


const NavigationBarResponsiveWidth = "800px";

export default class WelcomePage extends React.Component {
	state = {
		isNarrowScreen: window.matchMedia(`(max-width: ${NavigationBarResponsiveWidth})`).matches,
	}

	onGetStartedButtonClicked = this.props.onGetStartedButtonClicked;

	componentDidMount() {
		window.addEventListener('resize', () => {

			this.setState({
				isNarrowScreen: window.matchMedia(`(max-width: ${NavigationBarResponsiveWidth})`).matches,
			});
		});
	}

	render() {
		const StyledSwiperSlide = styled(SwiperSlide)(({ theme }) => ({
			boxSizing: "border-box",
			padding: this.state.isNarrowScreen ? "0px 0px" : "0px 50px",

		}));

		const pagination = {
			clickable: true,
			renderBullet: function (index, className) {
				return '<span class="' + className + '">' + (index + 1) + "</span>";
			},
		};

		return <Box sx={{
			textAlign: "center",
			// fontWeight: "bold",
			position: "relative",
			backgroundColor: "transparent",

			width: "100%",


			display: "flex",
			flexDirection: "column",
			alignItems: "center",

			height: "100%",
			// height: "fit-content",
			// overflow: this.state.isNarrowScreen? "scroll" : "hidden",



		}}>

			<Box sx={{
				position: "absolute",
				top: 0,
				bottom: 0,
				margin: "auto auto",
				width: "100%",

				// maxHeight: "400px",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",

				// height: this.state.isNarrowScreen ? null : "fit-content",
			}}>
				<Box margin="auto"/>

				<Box sx={{ width: "100%", minHeight: "20px", bgcolor: "transparent"}} />

				<div className="PageTitle">{TextManager.getText("welcome")}</div>
				<Typography
					sx={{
						lineHeight: this.state.isNarrowScreen ? "120%" : "",
						fontSize: this.state.isNarrowScreen ? "18px" : "",
					}}
				>{TextManager.getText("welcome_message")}</Typography>

				<Box sx={{ width: "100%", minHeight: "20px", bgcolor: "transparent" }} />

				<StyledCard elevation={4}>
					<Swiper
						spaceBetween={0}
						centeredSlides={true}
						pagination={{
							clickable: true,
						}}
						navigation={!this.state.isNarrowScreen}
						modules={[Pagination, Navigation]}

						style={{
							// maxWidth: "100%",
							height: "100%"
						}}
					>
						<StyledSwiperSlide>
							<Stack justifyContent="center" alignItems="center" sx={{ width: "100%", height: "100%" }}>
								<img src={TextManager.language == "en"? tutorialImage1 : tutorialImageTC1} style={{ width: "200px" }} />
								<TutorialText dangerouslySetInnerHTML={{__html: TextManager.getText("welcome_guide_1")}}/>
							</Stack>
						</StyledSwiperSlide>

						<StyledSwiperSlide>
							<Stack justifyContent="center" alignItems="center" sx={{ width: "100%", height: "100%" }}>
								<img src={TextManager.language == "en"? tutorialImage2 : tutorialImageTC2} style={{ width: "200px" }} />
								<TutorialText dangerouslySetInnerHTML={{__html: TextManager.getText("welcome_guide_2")}}/>
							</Stack>
						</StyledSwiperSlide>

						<StyledSwiperSlide>

							<Stack justifyContent="center" alignItems="center" sx={{ width: "100%", height: "100%" }}>
								<img src={TextManager.language == "en"? tutorialImage3 : tutorialImageTC3} style={{ width: "200px" }} />
								<TutorialText dangerouslySetInnerHTML={{__html: TextManager.getText("welcome_guide_3")}}/>
							</Stack>
						</StyledSwiperSlide>

						<StyledSwiperSlide>

							<Stack justifyContent="center" alignItems="center" sx={{ width: "100%", height: "100%" }}>
								<img src={TextManager.language == "en"? tutorialImage4 : tutorialImageTC4} style={{ width: "200px" }} />
								<TutorialText dangerouslySetInnerHTML={{__html: TextManager.getText("welcome_guide_4")}}/>
							</Stack>
						</StyledSwiperSlide>


						<StyledSwiperSlide>

							<Stack justifyContent="center" alignItems="center" sx={{ width: "100%", height: "100%" }}>
								<img src={TextManager.language == "en"? tutorialImage5 : tutorialImageTC5} style={{ width: "200px" }} />
								<TutorialText dangerouslySetInnerHTML={{__html: TextManager.getText("welcome_guide_5")}}/>
							</Stack>
						</StyledSwiperSlide>
					</Swiper>
				</StyledCard >

				<Button 
					variant="contained"
					sx={{marginTop:"20px"}}
					onClick={this.onGetStartedButtonClicked}
				>
					{TextManager.getText("get_started")}
				</Button>

				<Box sx={{ width: "100%", minHeight: "20px", bgcolor: "transparent" }} />

				<Box margin="auto"/>
			</Box>
			{/* <Box sx={{ width: "100%", height: "40px", bgcolor: "transparent" }} /> */}
		</Box>
	}
}
